import React from 'react'
import { OfferBenefits } from './OfferBenefits'
import { OfferModules } from './OfferModules'
import { OfferUsers } from './OfferUsers'

export const OfferSection: React.FC = () => {
    return (
        <div className="flex px-4 py-10 justify-center bg-[#181818] rounded-t-3xl">
            <div className="flex flex-col w-full lg:w-[940px] gap-4 items-center">
                <OfferUsers />
                <OfferBenefits />
                <OfferModules />
            </div>
        </div>
    )
}
